var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import SectionMenu from "./SectionMenu.vue";
import Component from 'vue-class-component';
import MessageService from "../../api/MessageService";
import MessageItem from "../newMassage/MessageItem.vue";
import { mapGetters } from "vuex";
import Empty from "./Empty.vue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.msgData = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = MessageService.getInstance();
    };
    default_1.prototype.mounted = function () {
        this.getMsg();
    };
    default_1.prototype.getMsg = function () {
        var _this = this;
        this.service.getMessage().then(function (res) {
            if (res.data.success) {
                var data = res.data.data.slice(0, 10);
                _this.msgData = data;
                _this.msgData.map(function (item) {
                    var curDate = new Date(item.c_time.toDate());
                    var month = _this.trantime(curDate.getMonth() + 1), day = _this.trantime(curDate.getDate()), hour = _this.trantime(curDate.getHours()), minute = _this.trantime(curDate.getMinutes());
                    item.trantime = (month) + "/" + day + " " +
                        hour + ":" + minute;
                });
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.toMsgPage = function () {
        this.$emit("to-detail");
    };
    default_1.prototype.trantime = function (num) {
        return num > 9 ? num : "0" + num.toString();
    };
    default_1.prototype.toWarnDetail = function (row) {
        this.$emit('toWarnDetail', row);
    };
    default_1 = __decorate([
        Component({
            components: {
                SectionMenu: SectionMenu,
                MessageItem: MessageItem,
                Empty: Empty
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList'
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
